import React, { useState, useEffect } from "react";
import PhotoAlbum from "react-photo-album";
import { volleybollPhotos, sportPhotos, cafePhotos, torontoPhotos, resorPhotos } from "./photos";
import "react-photo-album/styles.css";
import "./App.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";

function App() {
  const [index, setIndex] = useState(-1);

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  const handleClick = (index) => {
    setIndex(index);
  };

  return (
    <div className="app">
      <nav className="navbar">
  <div className="nav-left">
    <h1 className="main-title">Anton Olavi</h1>
  </div>
  <div className="nav-right">
    <a href="mailto:olaviproductions@gmail.com">Kontakta mig</a>
  </div>
</nav>

          <h2 className="section-title">Sverige vs Azerbajdzjan</h2>
      <h3 className="section-subtitle">6/6 2025</h3>
      <PhotoAlbum
        layout="rows"
        photos={volleybollPhotos}
        targetRowHeight={200}
        onClick={({ index }) => handleClick(index)}
        renderPhoto={({ imageProps }) => (
          <img
            {...imageProps}
            alt={imageProps.alt || ""}
            onContextMenu={(e) => e.preventDefault()}
            draggable={false}
            style={{
              ...imageProps.style,
              userSelect: "none",
              pointerEvents: "auto",
            }}
          />
        )}
      />

      <h2 className="section-title">Umeå FC vs Örgryte IS</h2>
      <h3 className="section-subtitle">26/5 2025</h3>
      <PhotoAlbum
        layout="rows"
        photos={sportPhotos}
        targetRowHeight={200}
        onClick={({ index }) => handleClick(volleybollPhotos.length + index)}
        renderPhoto={({ imageProps }) => (
          <img
            {...imageProps}
            alt={imageProps.alt || ""}
            onContextMenu={(e) => e.preventDefault()}
            draggable={false}
            style={{
              ...imageProps.style,
              userSelect: "none",
              pointerEvents: "auto",
            }}
          />
        )}
      />

      <h2 className="section-title">Decourses Café</h2>
      <h3 className="section-subtitle">28/11 2024</h3>
      <PhotoAlbum
        layout="rows"
        photos={cafePhotos}
        targetRowHeight={200}
        onClick={({ index }) => handleClick(volleybollPhotos.length + sportPhotos.length + index)}
        renderPhoto={({ imageProps }) => (
          <img
            {...imageProps}
            alt={imageProps.alt || ""}
            onContextMenu={(e) => e.preventDefault()}
            draggable={false}
            style={{
              ...imageProps.style,
              userSelect: "none",
              pointerEvents: "auto",
            }}
          />
        )}
      />

         <h2 className="section-title">Toronto</h2>
      <h3 className="section-subtitle">Hösten 2024</h3>
      <PhotoAlbum
        layout="rows"
        photos={torontoPhotos}
        targetRowHeight={200}
        onClick={({ index }) => handleClick(volleybollPhotos.length + sportPhotos.length + cafePhotos.length + index)}
        renderPhoto={({ imageProps }) => (
          <img
            {...imageProps}
            alt={imageProps.alt || ""}
            onContextMenu={(e) => e.preventDefault()}
            draggable={false}
            style={{
              ...imageProps.style,
              userSelect: "none",
              pointerEvents: "auto",
            }}
          />
        )}
      />


      <h2 className="section-title">Gotland</h2>
        <h3 className="section-subtitle">16-19/7 2024</h3>
      <PhotoAlbum
        layout="rows"
        photos={resorPhotos}
        targetRowHeight={200}
        onClick={({ index }) => handleClick(volleybollPhotos.length + sportPhotos.length + cafePhotos.length + torontoPhotos.length + index)}
        renderPhoto={({ imageProps }) => (
          <img
            {...imageProps}
            alt={imageProps.alt || ""}
            onContextMenu={(e) => e.preventDefault()}
            draggable={false}
            style={{
              ...imageProps.style,
              userSelect: "none",
              pointerEvents: "auto",
            }}
          />
        )}
      />

      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={[...volleybollPhotos, ...sportPhotos, ...cafePhotos, ...torontoPhotos, ...resorPhotos]}
        plugins={[Zoom, Thumbnails]}
      />

      <footer className="footer">
        © {new Date().getFullYear()} Anton Olavi. All rights reserved.
      </footer>
    </div>
  );
}

export default App;
